<template>
  <b-container>
  </b-container>
</template>

<script>

export default {
  name: "PostCategories",
}
</script>

<style scoped>

</style>